import {
  faCopy,
  faPencilSquare,
  faTrash,
} from "@fortawesome/pro-regular-svg-icons";
import { Menu } from "@mui/material";
import React from "react";

import { Icon } from "@/components/ui-v2/Icon/Icon";
import { MenuItem } from "@/components/ui-v2/Menu/components/MenuItem";

import { Anchor, PoseActions } from "../../../../types";

interface PoseActionsMenuProps extends PoseActions {
  open: boolean;
  onClose: (event: React.MouseEvent) => void;
  anchor?: Anchor;
}

export const PoseActionsMenu = (props: PoseActionsMenuProps) => {
  const { open, anchor, onClose, onEdit, onDelete, onDuplicate } = props;
  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorPosition={{
        top: anchor ? anchor.y : 0,
        left: anchor ? anchor.x : 0,
      }}
      anchorReference="anchorPosition"
    >
      {onEdit && (
        <MenuItem icon={<Icon icon={faPencilSquare} />} onClick={onEdit}>
          Edit
        </MenuItem>
      )}
      {onDuplicate && (
        <MenuItem onClick={onDuplicate} icon={<Icon icon={faCopy} />}>
          Duplicate
        </MenuItem>
      )}
      {onDelete && (
        <MenuItem onClick={onDelete} icon={<Icon icon={faTrash} />}>
          Delete
        </MenuItem>
      )}
    </Menu>
  );
};
